export default __webpack_public_path__ + "static/media/config-hub-01.c0fc0f94.png";